"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Lineageos = function Lineageos(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.6453 12.0573a2.404 2.404 0 00-1.803.7993l-.1382-.054a17.801 17.801 0 00-2.8667-.8594 4.8078 4.8078 0 00-9.6156 0h-.1322a17.7469 17.7469 0 00-2.7645.8353l-.1382.0541a2.404 2.404 0 10.5589 1.0697 16.599 16.599 0 012.5782-.7752 4.8078 4.8078 0 009.3572 0 16.557 16.557 0 012.5782.7692 2.404 2.404 0 102.3859-1.839zM2.414 15.6633a1.202 1.202 0 111.202-1.202 1.202 1.202 0 01-1.202 1.202zm9.6156 0a3.6059 3.6059 0 113.6059-3.606 3.6059 3.6059 0 01-3.6059 3.606zm9.6157 0a1.202 1.202 0 111.202-1.202 1.202 1.202 0 01-1.202 1.202zm-7.8127-3.606a1.803 1.803 0 11-1.803-1.8029 1.803 1.803 0 011.803 1.803Z"
  }));
};

Lineageos.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Lineageos.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Lineageos;
exports["default"] = _default;